export const APP_STORE_IOS = 'https://itunes.apple.com/us/app/firefly-health/id1396647655'
export const APP_STORE_ANDROID =
  'https://play.google.com/store/apps/details?id=com.fireflyhealth2&hl=en_US'

export enum BenefitAdministrationType {
  FIREFLY = 'firefly',
  EXTERNAL = 'external',
}

export const FIREFLY_SUPPORT_CONTACT = '1-888-897-1887'
